import React from 'react';
import { UserStatus } from 'Store/User/PropTypes';
import UserManagementItem from "../../Molecules/UserManagement/UserManagementItem";
import './user-management.scss';


export interface UserManagmentProps {
    users: any
}

export const UserManagement = ({users}: UserManagmentProps) => {
    return (
        <div className={'users-wrapper'}>
            { users.map((user: any) => <UserManagementItem user={user} isBlocked={user.blocked} key={user.email}/>) }
            { users.length <= 0 && <div style={{padding: '15px'}}>No users found...</div> }
        </div>
    )
}
